type StoryblokFocusModifiers = {filters?: {focal: string}};

const EMPTY_MODIFIERS: StoryblokFocusModifiers = {};
const modifiersByFocus = new Map<string, StoryblokFocusModifiers>();

export function storyblokFocusModifiers(focus?: string | null): StoryblokFocusModifiers {
	if (!focus) {
		return EMPTY_MODIFIERS;
	}

	const cached = modifiersByFocus.get(focus);
	if (cached) {
		return cached;
	}

	const modifiers: StoryblokFocusModifiers = {filters: {focal: focus}};
	modifiersByFocus.set(focus, modifiers);
	return modifiers;
}
